import React from 'react';
import { connect } from 'react-redux';
import { fetchAdministrationRetourExclus } from 'store/administration/administrationActions';

import { postRetourExclu } from 'store/administration/administrationActions';
import { deleteRetourExclu } from 'store/administration/administrationActions';

import AdministrationRetourExclus from './AdministrationRetourExclus';
import withLoader from 'components/Shared/withLoader';

const AdministrationRetourExclusWithLoader = withLoader(AdministrationRetourExclus);

class AdministrationRetourExclusContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            addRetourExcluDialogOpen: false,
            deleteRetourExcluDialogOpen: false,
            retourExcluToDelete: null
        };
    }

    async componentDidMount() {
        await this.props.fetchAdministrationRetourExclus();
    }


    handleOpenAddDialog = () => {
        this.setState({
            addRetourExcluDialogOpen: true
        });
    };
    handleCloseAddDialog = () => {
        this.setState({
            addRetourExcluDialogOpen: false
        });
    };

    addRetourExclu = async (retourExclu) => {
        await this.props.postRetourExclu(retourExclu);
    };
             


    handleOpenDeleteDialog = (retourExcluId) => {
        this.setState({
            deleteRetourExcluDialogOpen: true,
            retourExcluToDelete: this.props.retourExclus.find(x => x.id === retourExcluId)
        });
    };
    handleCloseDeleteDialog = () => {
        this.setState({
            deleteRetourExcluDialogOpen: false,
            retourExcluToDelete: null
        });
    };
    

    deleteRetourExclu = async (retourExcluId) => {
        this.setState({
            deleteRetourExcluDialogOpen: false
        });
        await this.props.deleteRetourExclu(retourExcluId);
    };

    render() {
        const { isLoading, niveaux, retourExclus } = this.props;

        return (
            <AdministrationRetourExclusWithLoader
                isLoading={isLoading}
                niveaux={niveaux}
                retourExclus={retourExclus}

                addRetourExcluDialogOpen={this.state.addRetourExcluDialogOpen}
                addRetourExclu={this.addRetourExclu}
                onOpenAddDialog={this.handleOpenAddDialog}
                onCloseAddDialog={this.handleCloseAddDialog}


                deleteRetourExcluDialogOpen={this.state.deleteRetourExcluDialogOpen}
                deleteRetourExclu={this.deleteRetourExclu}
                onOpenDeleteDialog={this.handleOpenDeleteDialog}
                onCloseDeleteDialog={this.handleCloseDeleteDialog}
                retourExcluToDelete={this.state.retourExcluToDelete}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    let niveaux = state.administration.retourExclus.niveaux;
    let retourExclus = state.administration.retourExclus.items;

    // TODO frais par niveaux

    return {
        isLoading: state.administration.retourExclus.isLoading,
        niveaux: niveaux,
        retourExclus: retourExclus
    };
};


const mapDispatchToProps = {
    fetchAdministrationRetourExclus,
    postRetourExclu,
    deleteRetourExclu
};

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationRetourExclusContainer);